import React from 'react';
import './Bumpups.css';

const services = [
  {
    title: 'Timestamp Studio',
    description: 'Instant, chapter-perfect YouTube timestamps crafted by AI that understands your story arc and audience intent.',
    variant: 'light',
  },
  {
    title: 'Creator Session Tracker',
    description: 'Automatically capture research, scripting, editing, and publishing time so every project has a replayable production timeline.',
    variant: 'accent',
  },
  {
    title: 'Content Sync Orchestrator',
    description: 'Distribute approved timestamps, descriptions, and assets across YouTube, podcasts, shorts, and newsletters in a single click.',
    variant: 'dark',
  },
  {
    title: 'Audience Insight Radar',
    description: 'Blend watch-time, sentiment, and conversion data into clear next-step guidance that keeps your channel growing.',
    variant: 'light',
  },
  {
    title: 'Collaboration Review Rooms',
    description: 'Invite editors, sponsors, and stakeholders to comment on exact timestamp moments and approve faster with audit-ready trails.',
    variant: 'accent',
  },
  {
    title: 'Automation Blueprint Lab',
    description: 'Build no-code triggers like “new video uploaded” or “timestamp approved” to automate notifications, tasks, and asset handoffs.',
    variant: 'dark',
  },
];

const Bumpups = () => {
  return (
    <section className="bumpups" id="services">
      <div className="bumpups-container">
        <div className="bumpups-header">
          <div className="header-title">
            <span className="section-tag">Stamp Sage Services</span>
            <h2 className="bumpups-title">AI copilots for every moment from recording to release</h2>
          </div>
          <p className="bumpups-subtitle">
            Stamp Sage unites Timestamp with time tracking, collaboration, and growth intelligence so your videos ship faster,
            stay consistent, and perform better channel-wide.
          </p>
        </div>

        <div className="bumpups-grid">
          {services.map((service) => (
            <article key={service.title} className={`bumpup-card ${service.variant}`}>
              <div className="card-body">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
              <a className="learn-more" href="#contact">
                <span>Learn more</span>
                <span className="learn-icon" aria-hidden="true">↗</span>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Bumpups;
